import React from 'react'
// import emoji from '../react-easy-emoji'
// import {CloudinaryContext, Image, Transformation} from 'cloudinary-react'
import PropTypes from 'prop-types'
import CartAddToCartButton from './CartAddToCartSimpleButton'
import MagGlass from './MagGlassIcon'
import makeCloudinaryUrlForPhoto from './makeCloudinaryUrlForPhoto'
import {Link} from 'react-router-dom'
import IconAddToBagSVG from './IconAddToBagSVG'
import {get} from 'lodash'


import './MenuCategoryListView.scss'
import './MenuCategoryListViewDarkModeOveride.scss'
import { is } from 'core-js/core/object'
let MAX_ITEMS = 50

class MenuCategoryListView extends React.Component {

  state = {
    showAll: true
  }
  showRestOfCategory= () => {
    this.setState({ showAll: true })
  }
  render() {

    let className="photos grid"
    let isGallery = false
    let items = this.props.items
    let disableOrder = this.props.disableOrder
    let noPhoto = this.props.noPhoto
    let altStyleA = this.props.altStyleA
    const noOrder = this.props.noOrder
    const settings = this.props.settings
    const compactMode = this.props.compactMode

    

    let tagsCss = this.props.tags ? (' ' + this.props.tags) : ''
    let compactCss = compactMode ? ' compact-mode' : ''
    let itemsToDisplay = this.state.showAll ? items : items.slice(0,MAX_ITEMS)
    return (
      <div className={"menu-category-list-view" + (altStyleA ? " alt-style-a" : "") + compactCss}>

        {/* List/Grid of Items */}
        <div className={className + tagsCss}>
          {itemsToDisplay.map(
            i => <MenuItem isGallery={isGallery}
              settings={settings}
              disableOrder={disableOrder}
              noOrder={noOrder}
              altStyleA={altStyleA}
              compactMode={compactMode}
              key={i.id} {...i}
              noPhoto={noPhoto}
              openPhotoSwipeGallery={this.props.openPhotoSwipeGallery}
              width={compactMode ? 80 : this.props.width}></MenuItem>)}
        </div>



        </div>
    );
  }
}

export default MenuCategoryListView

class MenuItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    // console.log(name)
    let {altStyleA, noOrder, noPhoto, id, name, photo, width='600', description, mandatory, price, modgroups, originalPrice, modifiers, tags, settings, compactMode } = this.props
    const menuQuickUpdates = get(settings, 'menu', {})
    let cashbackPercentageAsInteger = Number(get(settings, 'cashbackPercentageAsInteger', 0));
    if (isNaN(cashbackPercentageAsInteger)) cashbackPercentageAsInteger = 0;
    // console.log('menuQuickUpdates', menuQuickUpdates)

    if (!price && modgroups && modgroups[0]) {
      // make price from modifiers
      const firstModifiers = modgroups[0].modifiers || [];
      let options = firstModifiers.map((modifier) => {
        if (typeof modifier.price === 'number') {
          return `${modifier.name}: $${modifier.price}`;
        } else {
          return `${modifier.name}`;
        }
      });
      let priceText = options.length ? 'Options: ' + options.join(', ') : '';
      price = priceText;
    }

    let cssExtras = ''
    let disableOrderText = '*not availalbe online'
    name = name || {}
    let chinese = name.zh
    let korean  = name.kr
    name = (name && name.en) || "untitled"
    let isHalal = name.toLowerCase().indexOf('halal') !== -1
    if ((tags || "").indexOf('halal') !== -1) {
      isHalal = true
    }
    description = description && description.en
    let cssItemTags = tags ? " " + tags : ""
    if (isHalal) {
      cssItemTags += " halal"
    }
    

    let cloudinaryURL
    if (photo) {
      cloudinaryURL = makeCloudinaryUrlForPhoto(photo, {width})
    }

    let dineInOnly = (name.indexOf('Dine-In Only') !== -1)
    let disableOrder = this.props.disableOrder || dineInOnly
    if (menuQuickUpdates[id] && menuQuickUpdates[id].outOfStock === 'OUT_OF_STOCK') {
      disableOrder = true
      disableOrderText = '*OUT OF STOCK'
    }

    // OVERWRITE from menu updater
    if (menuQuickUpdates[id]) {
      if (menuQuickUpdates[id].name?.en) {
        name = menuQuickUpdates[id].name.en;
      }
      if (menuQuickUpdates[id].description?.en) {
        description = menuQuickUpdates[id].description.en;
      }
      if (menuQuickUpdates[id].price !== undefined && menuQuickUpdates[id].price !== null) {
        price = menuQuickUpdates[id].price;
      }
    }

  

    
    if (noOrder) {
      disableOrder = true
      disableOrderText = ''
    }

    // Compact mode rendering
    if (compactMode) {
      if (photo) {
        cloudinaryURL = makeCloudinaryUrlForPhoto(photo, {width: 80, height: 80})
      }
      
      return (
        <section className={"menu-item compact" + cssItemTags}>
          <Link
            className="item-link"
            aria-label={`customize ${name} and add to cart`}
            to={disableOrder ? "#" : (`/products/${id}`)}
          >
            {cloudinaryURL && !noPhoto && (
              <div className="compact-photo">
                <img
                  loading="lazy"
                  src={cloudinaryURL}
                  alt={"photo of " + name}
                />
              </div>
            )}
            <div className="compact-content">
              <span className="food-name">{name}</span>
              <span className="item-price">
                {(Number(price)) ? '$' : ''}{price}
              </span>
            </div>
            {(!disableOrder) && (
              <span className="compact-add">+</span>
            )}
          </Link>
        </section>
      )
    }
    
    if (altStyleA) {
      const menuItemPhotoStyle = photo ? " has-photo" : " no-photo"
      if (photo) {
        cloudinaryURL = makeCloudinaryUrlForPhoto(photo, {height: 300})
      }

      return(
        <section
            className={"menu-item" + menuItemPhotoStyle + cssItemTags}
            
            >
         {isHalal ? <span className="halal-icon">
            <img src="https://afag.imgix.net/crave-cafe-west-hills/halal-logo-1.png" alt="halal product" />
          </span>
          : null
          }
        <Link
            className="item-link"
            aria-label={`customize ${name} and add to cart`}
            title={`customize ${name} and add to cart`}
            to={disableOrder ? "#" : (`/products/${this.props.id}`)}
            >
        <div className="content">
        <header>
       
          <span
            id={'p_' + id}
            className="food-name">{name}</span>
          
        </header>
    
          
          {originalPrice ? <div className="discount-price">${originalPrice} </div> : null}
          {(true) ? <div className="item-price">
            {/* {(!disableOrder) ? <IconAddToBagSVG className="add-to-bag-icon"></IconAddToBagSVG> : null} */}
            {(Number(price)) ? '$' : ''}
            {price}
            
            
            
          
          </div> : null}

          {disableOrder ? <div style={{fontStyle: "italic", fontSize: '0.8em'}} className="dine-in-only"> {disableOrderText} </div> : null}

          <p className="menu-item-description">
          {korean ? <span>{korean} ·</span> : ''} 
          {description}</p>

          {(!disableOrder) ? 
        <div className="add-to-cart-button-wrapper">
          <span className="plus-sign">
            +
          </span>
        </div> : null}
      </div>
      </Link>
        {cloudinaryURL && !noPhoto && <div
          className="photo-container-2"
          // onClick={this.props.openPhotoSwipeGallery.bind(this, id)}
          >
            <Link
            to={disableOrder ? "#" : (`/products/${this.props.id}`)}
            >
              <img
                loading="lazy"
                decoding="async"
                fetchpriority="low"
                src={cloudinaryURL}
                alt={"photo of " + name}

              />
            </Link>
            {/* <MagGlass></MagGlass> */}
        </div>}


        

      </section>
      )
    }

    return (

        <section className={"menu-item" + cssExtras}>
          {cloudinaryURL && !noPhoto && <div
            className="photo-container"
            onClick={this.props.openPhotoSwipeGallery.bind(this, id)}>
              <img
                src={cloudinaryURL}
                alt={""}
              />
              {/* <MagGlass></MagGlass> */}
          </div>}
        <div className="content">
          <header>
            <span
              id={'p_' + id}
              className="food-name">{name}</span>
          </header>
          <p className="menu-item__description">
            {korean ? <span>{korean} ·</span> : ''} 
            {description}</p>
        </div>
        <div className="all-prices">
       {originalPrice ? <div className="discount-price">${originalPrice} </div> : null}
          {!disableOrder &&
            <Link
              className="product-link"
              aria-label={`customize ${name} and add to cart`}
              title={`customize ${name} and add to cart`}
              to={`/products/${this.props.id}`}>
          
          
                <span className="plus">+</span> <span className="price">${price}</span>
          
              </Link>}
        </div>
          {disableOrder && <span className="price">${price} (OUT OF STOCK)</span>}
        </section>

    );
  }
}
